import React from "react";
import { styled } from "@mui/material/styles";
import { Box, BoxProps, InternalStandardProps } from "@mui/material";
import { AppTypography } from "JS/React/Components/AppTypography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AppCompletionProgress } from "JS/React/Components/AppCompletionProgress";
import { GraphicEq as GraphicEqIcon } from "@mui/icons-material";
import { messaging } from "JS/Helpers/UserMessaging";

const StyledRoot = styled(Box)({
    width: "100%",
    minHeight: "90px",
});

const ListTitleWrapper = styled(Box)({
    display: "flex",
    alignItems: "center",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "100%",
    padding: "2%",
});

const ProgressMainWrapper = styled(Box)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
});

const ProgressWrapper = styled(Box)({
    width: "95%",
});

const ListIconsWrapper = styled(Box)(({ theme }) => ({
    width: "10%",
    margin: theme.spacing(1),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
}));

const ListMainIcon = styled(FontAwesomeIcon)(({ theme }) => ({
    fontSize: "25px",
    color: theme.palette.grey[600],
}));

const ContentTitleWrapper = styled(Box)({
    width: "90%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
});

const ContentTitle = styled(AppTypography)(({ theme }) => ({
    width: "95%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: theme.palette.primary.main,
}));

const StyledGraphicEqIcon = styled(GraphicEqIcon)(({ theme }) => ({
    color: theme.palette.grey[600],
}));

export interface QueueItemsProps extends InternalStandardProps<BoxProps> {
    onCancelDownload?: () => void;
    contentTitle: string;
    isDownloading: boolean;
    timeRemaining?: string;
    downloadingSpeed?: string;
    downloadPercentage?: number;
    isShowProgress?: boolean;
    contentType?: string;
    status?: string;
}

export const QueueItems = (props: QueueItemsProps) => {
    const {
        className,
        isDownloading,
        onCancelDownload,
        downloadingSpeed,
        contentTitle,
        timeRemaining,
        downloadPercentage,
        isShowProgress,
        contentType,
        status,
        ...rest
    } = props;
    return (
        <StyledRoot {...rest} className={className}>
            <ListTitleWrapper>
                <ListIconsWrapper>
                    {(contentType === "video" ||
                        contentType === "giftVideo" ||
                        contentType === "courseVideo") && (
                        <ListMainIcon icon={["fas", "video"]} />
                    )}
                    {contentType === "document" ||
                        (contentType === "coursePdf" && (
                            <ListMainIcon icon={["far", "clipboard"]} />
                        ))}
                    {(contentType === "audio" ||
                        contentType === "giftAudioBundle" ||
                        contentType === "audioBundle" ||
                        contentType === "giftAudio" ||
                        contentType === "courseMP3") && (
                        <StyledGraphicEqIcon fontSize="large" />
                    )}
                </ListIconsWrapper>
                <ContentTitleWrapper>
                    <ContentTitle variant="h6">{contentTitle}</ContentTitle>
                    <ContentTitle variant="body1">
                        {isDownloading || status === "inProgress"
                            ? `${messaging.downloadingQueue.downloading}`
                            : `${messaging.downloadingQueue.Queued}`}
                    </ContentTitle>
                </ContentTitleWrapper>
            </ListTitleWrapper>
            <ProgressMainWrapper>
                <ProgressWrapper>
                    {isShowProgress && (
                        <AppCompletionProgress
                            isDownloadingQueue={true}
                            loading={false}
                            title={downloadingSpeed}
                            lowerTitle={timeRemaining}
                            value={
                                !isDownloading && status === "inProgress"
                                    ? 100
                                    : downloadPercentage
                            }
                        />
                    )}
                </ProgressWrapper>
            </ProgressMainWrapper>
        </StyledRoot>
    );
};
